import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import Button from 'antd/lib/button';
import AllocationsFilter from './AllocationsFilter';
import { Icon } from 'antd';

const NoAllocations = ({ t, filter, onTurnFilterOff, onChange, total, count, minMonths, maxMonths, interestMin, interestMax }) => {
  
  const somethingInFilter = filter.type === '' &&
                            filter.status === '' &&
                            filter.createdAt.length === 0 &&
                            filter.interest.length === 0 &&
                            filter.months.length === 0

  const [toggleFilter, setToggleFilter] = useState(!somethingInFilter)


  const toggleFilterState = () => {
    if (toggleFilter) {
      
      onTurnFilterOff()
    }
    setToggleFilter(!toggleFilter)
  }
  
  return (
  <div>
    <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>   
        <Button onClick={() => toggleFilterState()}><Icon type="filter" /> Filter {!somethingInFilter ? `(Nájdených 0 z ${total} investícií)` : ""}</Button>
    </div>
    {
      toggleFilter && <div style={{paddingBottom: 30+'px'}}> 
      <AllocationsFilter 
        filter={filter}
        onChange={onChange}
        total={total}
        count={count}
        minMonths={minMonths}
        maxMonths={maxMonths}
        interestMin={interestMin}
        interestMax={interestMax}
      />
      </div>
    }    
    <section className="panel-wrapper text-center">
      <h2>{t('Nemáte žiadne investície')}</h2>
      <Row center="xs">
        <Col xs={12} sm={8}>
          <p style={{ marginBottom: 20 }}>
            {t(
              'Momentálne nemáte vytvorené žiadne investície. Začnite s nami investovať stlačením tlačidla Nová investícia.'
            )}
          </p>
          <Link to="dashboard/create-investment">
            <Button type="primary" size="default">
              {t('Nová investícia')}
            </Button>
          </Link>
        </Col>
      </Row>
    </section>
  </div>
  
)};

NoAllocations.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(NoAllocations);



// WEBPACK FOOTER //
// ./src/features/allocations/components/NoAllocations.js